import React, {useEffect, useState} from 'react'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'
import Layout from '../components/Layout'

const Eula = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [themeStyles])

    return (
        <Layout title="Eula" description="" lang={lang} canonicalPath="/eula/" themeStyles={themeStyles} theme={theme}>
            <section
                className="wrapper"
                css={css`
                    max-width: 100%;
                    overflow: hidden;
                    padding: 0 2rem 2rem 2rem;
                    min-height: 500px;
                    background: ${themeStyles.primaryBackgroundColor};
                `}
            >
                <div
                    className="eulaContent"
                    css={css`
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        width: 100%;
                        max-width: 100%;
                        margin: 110px auto 0 auto;
                        max-width: 1200px;
                        line-height: 24px;
                        color: ${themeStyles.primaryTextColor};

                        @media (max-width: 400px) {
                            margin: 130px auto 0 auto;
                        }

                        h1 {
                            text-align: center;
                            font-size: 30px;
                            line-height: 42px;
                            color: ${themeStyles.primaryTextColor};

                            &:last-of-type {
                                margin-bottom: 2rem;
                            }
                        }

                        ol {
                            list-style-type: lower-alpha;
                            margin: 0;
                        }

                        ul {
                            margin: 0;
                            list-style-type: disc;
                        }

                        li {
                            margin: 1rem 0;
                            color: ${themeStyles.primaryTextColor};
                        }

                        p {
                            margin: 1rem 0;
                            color: ${themeStyles.primaryTextColor};
                        }

                        strong {
                            color: ${themeStyles.primaryTextColor};
                        }

                        a {
                            color: ${themeStyles.linkColor};
                        }
                    `}
                    // dangerouslySetInnerHTML={createMarkup(eulaContent)}
                >
                    <h1>Startpage</h1>
                    <h1>Chrome Extension</h1>
                    <h1>End User License Agreement</h1>
                    <p>Last updated: August 17, 2021.</p>
                    <p>
                        <strong>THIS END USER LICENSE AGREEMENT</strong>
                    </p>
                    <p>
                        This End User License Agreement (this “Agreement”) is a legally binding agreement. Please read
                        it carefully. By clicking to agree or accept or otherwise indicating your acceptance of this
                        Agreement, or by installing or using the Startpage software and/or any updates to such software
                        (collectively, the “Software”) provided by Startpage BV, a wholly-owned subsidiary of System1
                        LLC (“Startpage”), you agree to the terms of this Agreement. If you do not agree to these terms,
                        you may not install or use the Software. This Agreement is effective between you and Startpage
                        as of the date you first download, install or use the Software, whichever is earliest. You are
                        responsible for reading and complying with any amended version of this Agreement that is made
                        available by Startpage via the Software or the Google Chrome Web Store, or that is posted at
                        add.startpage.com/protection.
                    </p>
                    <p>
                        <strong>THE SOFTWARE AND LICENSE</strong>
                    </p>
                    <p>
                        The Software allows users to use certain features relating to Startpage in a Google Chrome
                        browser from Supported Devices. A “Supported Device” is a combination of a Google Chrome-enabled
                        device model and relevant Google Chrome software version(s) that is/are supported by the
                        Software.
                    </p>
                    <ol>
                        <li>
                            The Software, including software embedded in the Software, is licensed, not sold, to you by
                            Startpage only under the terms of this Agreement; and Startpage reserves all rights not
                            expressly granted under this Agreement. Startpage does not own the media or device on which
                            the Software is recorded or stored, but Startpage retains ownership of the Software itself.
                        </li>
                        <li>
                            No rights are granted with respect to Software under, and the Software is not licensed or
                            otherwise provided under, any master subscription agreement or other agreement between
                            Startpage and you or any Startpage customer with which you are employed, affiliated or
                            associated.
                        </li>
                        <li>
                            Startpage may do any of the following at any time, with or without notice or cause, and
                            without any liability to you: (a) change, suspend, or terminate any features or
                            functionality of the Software; (b) impose limits on certain features or functionality of the
                            Software; or (c) terminate this Agreement. Upon any such termination, you will no longer be
                            permitted to use the Software, and will delete or destroy all copies of the Software in your
                            possession. Modification, suspension, or termination of the Software or this Agreement will
                            not entitle you to any refund, credit, or other compensation from Startpage under this
                            Agreement or any other agreement or from any third party.
                        </li>
                    </ol>

                    <p>
                        <strong>PERMITTED LICENSE USES AND RESTRICTIONS</strong>
                    </p>

                    <ol>
                        <li>
                            This Agreement allows you to use the Software on any Supported Device and on no other
                            devices. The Software is available only for Supported Devices, and may not be available for
                            all devices.
                        </li>
                        <li>
                            You may not distribute or make the Software available over a network where it could be used
                            by multiple devices at the same time.
                        </li>
                        <li>
                            You may not sell, resell, rent, lease, lend, redistribute, sublicense, or otherwise make the
                            Software available.
                        </li>
                        <li>
                            With respect to updates to the Software that Startpage may make available for download, this
                            Agreement allows you to download such Software updates to update or restore the Software on
                            any Supported Device.
                        </li>
                        <li>
                            The Software is protected by copyright laws and international treaties. Except as and only
                            to the extent permitted by applicable law, or by licensing terms governing use of
                            open-sourced components included with the Software, you may not copy, decompile, reverse
                            engineer, disassemble, attempt to derive the source code of, decrypt, modify, or create
                            derivative works of the Software or Software updates, or any part thereof. Any attempt to do
                            so is a violation of this Agreement and of the rights of Startpage and/or its licensors. If
                            you violate this restriction, you may be subject to prosecution and damages.
                        </li>
                        <li>
                            You may not use the Software to submit or link to any content that, in Startpage’s sole
                            discretion:
                            <ul>
                                <li>Violates any applicable law or regulation;</li>
                                <li>
                                    Infringes or violates the intellectual property or other rights of any person or
                                    entity;
                                </li>
                                <li>Intentionally interferes with the operation of the Software;</li>
                                <li>
                                    Harasses, offends, threatens, embarrasses, distresses or invades the privacy or
                                    publicity rights of any individual or entity;
                                </li>
                                <li>Breaches any duty of confidentiality that you owe to any person or entity;</li>
                                <li>
                                    Is vulgar, offensive, inappropriate, harassing, defamatory, abusive, lewd,
                                    pornographic, obscene or otherwise objectionable; or
                                </li>
                                <li>
                                    Contains or installs any viruses, worms, bugs, Trojan horses, malware or other code,
                                    files or programs designed or having the capability to disrupt, damage or limit the
                                    functionality of any software or hardware;
                                </li>
                            </ul>
                        </li>
                        <li>
                            Without limiting the generality of anything herein, you acknowledge and agree that the
                            Software may collect user or device data for the purposes of providing services or functions
                            that are relevant to use of the Software.
                        </li>
                        <li>
                            Without limiting the generality of anything herein, you are responsible for complying with
                            applicable laws and government regulations in your use of the Software.
                        </li>
                    </ol>

                    <p>
                        <strong>GOOGLE LLC (“GOOGLE”) TERMS</strong>
                    </p>

                    <ol>
                        <li>
                            This Agreement is between you and Startpage only, and not with Google. Startpage is solely
                            responsible for the Software.
                        </li>
                        <li>
                            The Google Chrome Web Store is owned and operated by Google. Your use of the Google Chrome
                            Web Store is governed by a legal agreement between you and Google consisting of the Google
                            Chrome Web Store Terms of Service (found at{' '}
                            <a href="https://ssl.gstatic.com/chrome/webstore/intl/en/gallery_tos.html">
                                https://ssl.gstatic.com/chrome/webstore/intl/en/gallery_tos.html
                            </a>
                            ), and the Google Chrome Terms of Service (found at{' '}
                            <a href="https://www.google.com/chrome/privacy/eula_text.html">
                                https://www.google.com/chrome/privacy/eula_text.html
                            </a>
                            ).
                        </li>
                        <li>
                            Google and its affiliates are third-party beneficiaries of this Agreement, and have the
                            right (and will be deemed to have accepted the right) to enforce this Agreement against you.
                        </li>
                    </ol>

                    <p>
                        <strong>THIRD-PARTY COMPONENTS</strong>
                    </p>

                    <p>
                        The Software may include certain third-party components. Any applicable terms and/or notices
                        required by Startpage’s licensors for such components may be disclosed within the Software, on
                        the Google Chrome Web Store, on the Startpage website, or as otherwise disclosed or made
                        available by Startpage.
                    </p>

                    <p>
                        <strong>USE OF DATA</strong>
                    </p>

                    <p>
                        By using the Software, you acknowledge and agree to Startpage’s privacy statement available at{' '}
                        <a href="https://www.startpage.com/en/privacy-policy">
                            https://www.startpage.com/en/privacy-policy
                        </a>
                        , as may be amended from time to time (“Privacy Policy”). Without limiting the generality of the
                        foregoing, the Software may obtain information from, or access data stored on, a Supported
                        Device to provide and improve the Software and related products. The Software may provide
                        Startpage with information related to your use of the Software, information regarding your
                        computer system, and information regarding your interaction with the Software, which Startpage
                        may use to provide and improve the Software and related products. The Software’s access to
                        information through your device does not cause that information to be personal data or customer
                        data under the Privacy Policy.
                    </p>

                    <p>
                        <strong>DISCLAIMER OF WARRANTY</strong>
                    </p>

                    <p>
                        Neither Startpage nor its third-party providers warrant the Software will perform in accordance
                        with any specifications, documentation, or other standards, perform in an uninterrupted
                        capacity, be error-free or bug-free, provide complete or accurate data, nor do they make any
                        warranties as to the results to be obtained from the use of the Software. Use of the Software
                        and reliance thereon is at your sole risk. Neither Startpage nor its third-party providers will
                        in any way be liable to you or any other entity or person for their inability to use the
                        Software, or for any inaccuracies, errors, omissions, delays, computer viruses or other
                        infirmity or corruption, damages, claims, liabilities or losses, regardless of cause, in or
                        arising from the use of the Software. The Software is provided on an “as is” basis and without
                        warranty or any support or maintenance of any kind. No warranties, either express or implied,
                        including but not limited to any implied warranty of merchantability, fitness for a particular
                        purpose, title, non-infringement, or of any other type is provided hereunder. No oral or written
                        information or advice given by Startpage or its authorized representative will create a
                        warranty. Some jurisdictions do not allow the exclusion of implied warranties or limitations on
                        applicable statutory rights of a consumer, so the above disclaimer, exclusions and limitations
                        may not apply to you.
                    </p>

                    <p>
                        <strong>INDEMNIFICATION</strong>
                    </p>

                    <p>
                        YOU AGREE TO HOLD HARMLESS, DEFEND AND INDEMNIFY STARTPAGE, ITS OFFICERS, DIRECTORS, EMPLOYEES,
                        SUBSIDIARIES, CONTRACTORS, SUBCONTRACTORS, SUPPLIERS, AGENTS, PARTNERS AND AFFILIATES,
                        SUCCESSORS AND ASSIGNS FROM ALL LIABILITIES, CLAIMS, DEMANDS AND EXPENSES, INCLUDING REASONABLE
                        ATTORNEYS’ FEES, THAT ARE DUE TO, OR THAT ARISE FROM YOUR USE OR MISUSE OF THE SOFTWARE, OR FOR
                        INFRINGEMENT BY YOU OR OTHERS OF INTELLECTUAL PROPERTY RIGHTS OR OTHER RIGHT OF ANY THIRD PARTY.
                        STARTPAGE MAY ASSUME EXCLUSIVE CONTROL OF ANY DEFENSE OR ANY MATTER SUBJECT TO INDEMNIFICATION
                        BY YOU, AND YOU AGREE TO COOPERATE WITH STARTPAGE IN SUCH EVENT.
                    </p>

                    <p>
                        <strong>LIMITATION OF LIABILITY</strong>
                    </p>

                    <p>
                        IN NO EVENT WILL STARTPAGE, ITS OFFICERS, EMPLOYEES, CONTRACTORS, SUBCONTRACTORS, SUPPLIERS,
                        AGENTS, AFFILIATES, SUBSIDIARIES, SUCCESSORS OR ASSIGNS BE LIABLE TO ANY PARTY FOR ANY DIRECT,
                        INDIRECT, CONSEQUENTIAL, INCIDENTAL, SPECIAL OR OTHER INDIRECT (INCLUDING WITHOUT LIMITATION,
                        COST OF COVER) ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT OR THE SOFTWARE, EVEN IF
                        STARTPAGE IS EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND REGARDLESS OF WHETHER
                        SUCH DAMAGES AROSE IN CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHER LEGAL
                        BASIS. THE TERM “DAMAGES” INCLUDES, WITHOUT LIMITATION, ATTORNEY FEES, ANY LOST PROFITS,
                        BUSINESS INTERRUPTION AND LOSS OF PROGRAMS OR OTHER DATA ON YOUR INFORMATION HANDLING SYSTEM.
                        YOU ACKNOWLEDGE THAT THE ECONOMIC TERMS OF THIS AGREEMENT REFLECT THE FOREGOING ALLOCATION OF
                        RISK AND SUCH ALLOCATION OF RISK IS A SIGNIFICANT INDUCEMENT FOR STARTPAGE TO PROVIDE THE
                        SOFTWARE.
                    </p>

                    <p>
                        Some jurisdictions do not allow the limitation or exclusion of liability for incidental or
                        consequential damages, or have legislation that restricts the limitation or exclusion of
                        liability, so the above limitation may not apply to you.
                    </p>

                    <p>
                        <strong>INTERNATIONAL USE AND EXPORT LAWS</strong>
                    </p>

                    <p>
                        Startpage does not represent that all the Software is appropriate or available for use in all
                        geographic locations and accessing the Software from certain locations may be illegal and
                        prohibited. Those who do access content, materials and services from such locations act on their
                        own initiative and Startpage is not responsible for their compliance with local laws or other
                        applicable laws. You will not access the foregoing where prohibited by law. This Agreement
                        involves products and/or technical data that may be controlled under the laws and regulations of
                        the United States and other countries, including but not limited to the United States Export
                        Administration Regulations, or any other applicable law, regulation or order (“Export Laws”).
                        You will comply with all Export Laws to assure that the Software is not exported, directly or
                        indirectly, in contravention of the Export Laws.
                    </p>

                    <p>
                        <strong>GOVERNING LAW</strong>
                    </p>

                    <p>
                        This Agreement is governed by and will be construed in accordance with the laws of the State of
                        California, without regard to its conflict of laws rules. You expressly agree that the exclusive
                        jurisdiction for any claim or dispute relating to this Agreement and/or your use of the Software
                        resides in the state and federal courts located in Los Angeles County, California; and you
                        further expressly agree to submit to the exclusive personal jurisdiction of such courts for the
                        purpose of litigating any such claim or action. Notwithstanding the foregoing, Startpage may
                        seek injunctive relief in any court of competent jurisdiction.
                    </p>

                    <p>
                        <strong>GENERAL</strong>
                    </p>

                    <p>
                        This Agreement, including any terms incorporated in this Agreement, is the entire agreement
                        between you and Startpage relating to its subject matter, and supersedes all prior and
                        contemporaneous agreements, proposals or representations, written or oral, relating to that
                        subject matter; provided that nothing in this Agreement will limit your obligations to Startpage
                        or any of its affiliates, or limit the rights of Startpage or any of its affiliates, under any
                        other agreement between Startpage or any of its affiliates and (a) you or (b) any customer of
                        Startpage or any of its affiliates with which you are employed, affiliated or associated. If any
                        provision of this Agreement is held by a court of competent jurisdiction to be contrary to law
                        and/or not enforceable, that provision will be deemed null and void, and the remaining
                        provisions of this Agreement will remain in effect. You may not assign or transfer any of your
                        rights or obligations under this Agreement, whether by operation of law or otherwise. Startpage
                        may assign, transfer or sublicense any or all of its rights or obligations under this Agreement
                        without restriction. Startpage’s waiver of any breach under this Agreement will not be
                        considered a waiver of any earlier or later breach. No failure or delay by Startpage in
                        exercising any right under this Agreement will constitute a waiver of that right. Titles and
                        headings of sections of this Agreement are for convenience only and will not affect the
                        construction of any provision of this Agreement. The term “including” and its variations will be
                        interpreted as if followed by the phrase “without limitation.” Startpage will not be responsible
                        for any delay in fulfilling or failure to fulfill any obligation due to any cause beyond its
                        control. Each parent company, affiliate, and subsidiary of Startpage is an express third-party
                        beneficiary under this Agreement.
                    </p>
                </div>
            </section>
        </Layout>
    )
}

export default Eula
